"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import SelectComponent from "ui/common/bit/SelectComponent"
import { sizes } from "ui/theme/theme"
import { InvestmentFiltersProps } from "./types"

const StyledDropdownsContainer = styled(Box)`
  display: flex;
  gap: ${sizes.baseDouble};
  width: 100%;
  max-width: 300px;
  margin: ${sizes.baseSingle} 0;
  * > {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`

const InvestmentFilters = ({
  apiData,
  selectedCompanyId,
  selectedFundId,
  onCompanyChange,
  onFundChange,
}: InvestmentFiltersProps) => {
  return (
    <StyledDropdownsContainer>
      <SelectComponent
        options={apiData.funds.map((fund) => ({
          ...fund,
          name: `מסלול ${fund.name}`,
        }))}
        value={selectedFundId}
        onChange={onFundChange}
      />
      <SelectComponent
        options={apiData.companies}
        value={selectedCompanyId}
        onChange={onCompanyChange}
      />
    </StyledDropdownsContainer>
  )
}

export default InvestmentFilters
